var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1240"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.27217 5.25752C5.58265 4.94704 6.08605 4.94704 6.39654 5.25752L9.01455 7.8755L11.6326 5.25753C11.9431 4.94705 12.4464 4.94705 12.7569 5.25753C13.0674 5.56801 13.0674 6.07142 12.7569 6.3819L10.139 8.99991L12.7569 11.6179C13.0674 11.9284 13.0674 12.4318 12.7569 12.7423C12.4464 13.0527 11.9431 13.0527 11.6326 12.7423L9.01455 10.1243L6.39655 12.7423C6.08605 13.0527 5.58266 13.0527 5.27218 12.7423C4.96169 12.4318 4.96169 11.9284 5.27218 11.6179L7.89013 8.99991L5.27217 6.38189C4.96169 6.07141 4.96169 5.568 5.27217 5.25752Z",
    fill: "#4404BF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.04993 0.274355C7.32296 -0.0914518 10.706 -0.0914518 13.979 0.274355C15.9151 0.490736 17.4786 2.0158 17.7064 3.96309C18.0978 7.30962 18.0978 10.6904 17.7064 14.0369C17.4786 15.9842 15.9151 17.5092 13.979 17.7257C10.706 18.0914 7.32296 18.0914 4.04993 17.7257C2.11385 17.5092 0.550363 15.9842 0.322608 14.0369C-0.0687992 10.6904 -0.0687992 7.30962 0.322608 3.96309C0.550363 2.0158 2.11385 0.490736 4.04993 0.274355ZM13.8024 1.85461C10.6468 1.50192 7.38221 1.50192 4.22655 1.85461C3.01338 1.9902 2.04231 2.9477 1.90195 4.14781C1.52489 7.37164 1.52489 10.6284 1.90195 13.8522C2.04231 15.0523 3.01338 16.0098 4.22655 16.1454C7.38221 16.498 10.6468 16.498 13.8024 16.1454C15.0156 16.0098 15.9866 15.0523 16.127 13.8522C16.5041 10.6284 16.5041 7.37164 16.127 4.14781C15.9866 2.9477 15.0156 1.9902 13.8024 1.85461Z",
    fill: "#4404BF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.e044b825c911a6cea89bd0ca0cbace69.svg";
export { ForwardRef as ReactComponent };